export default __webpack_public_path__ + "static/media/calendar.57b2a5ba.jfif";